// extracted by mini-css-extract-plugin
export var standaloneTable = "_o-0";
export var standaloneTableWithBodyFill = "_o-1";
export var withExtraHeader = "_o-2";